// head-api-ssr.js
import React from "react";
import { useStaticQuery, graphql } from "gatsby";

const HeadApiSsr = ({ title, description, siteAuthor }) => {
  // Fetch default values from site metadata using GraphQL
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `);

  // Ensure default values are used when props are not passed
  const defaultTitle = title || site.siteMetadata.title;
  const defaultDescription = description || site.siteMetadata.description;
  const defaultAuthor = siteAuthor || site.siteMetadata.author;

  // Meta tags array
  const metaTags = [
    { property: "og:title", content: defaultTitle },
    { property: "og:description", content: defaultDescription },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { name: "twitter:creator", content: defaultAuthor },
    { name: "twitter:title", content: defaultTitle },
    { name: "twitter:description", content: defaultDescription },
  ];

  return (
    <>
      <meta name="msvalidate.01" content="2E5E301254F9DEB0B72E800F335D24FC" />
      {metaTags.map((metaTag, index) => (
        <meta
          key={index}
          name={metaTag.name}
          property={metaTag.property}
          content={metaTag.content}
        />
      ))}
    </>
  );
};

export default HeadApiSsr;